import React from 'react';
import styled from 'styled-components';
import withProductCondition from '@catalogo/service-americanas-product/src/hocs/product-condition';
import { ProductConditionsProps } from '@catalogo/service-americanas-product/src/helpers/product-condiction';
import Alert from './components/alert';
import Select from './components/select';

export const ProductConditions: React.FC<ProductConditionsProps> = props => {
  const { showAlert, onlyRewrapped, conditionSelected, setConditionSelected, parsedQs, history } = props;

  return (
    <Component>
      <Alert showAlert={showAlert} />
      <Select
        onlyRewrapped={onlyRewrapped}
        conditionSelected={conditionSelected}
        setConditionSelected={setConditionSelected}
        parsedQs={parsedQs}
        history={history}
      />
    </Component>
  );
};

const Component = styled.div`
  margin-top: 16px;

  @media (min-width: 700px) {
    display: flex;
    padding-top: 16px;
    padding-bottom: 0px;
    border-bottom: none;
    flex-direction: column-reverse;
    border-top: 1px solid #cecccc;
  }
`;

export default withProductCondition(ProductConditions);
